import {
  AfterViewInit,
  ViewChildren,
  QueryList,
  Component,
  OnInit,
  forwardRef,
  Injector,
  HostListener,
  ViewChild,
  AfterViewChecked,
  ElementRef,
  ChangeDetectorRef,
  OnDestroy,
  TrackByFunction
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { TitleService, _HttpClient, SettingsService } from '@delon/theme';
import { Store } from '@ngrx/store';
import { DeferredVatLookupService } from '@shared-feature/services/lookup-deferredvat.service';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import remove from 'lodash/remove';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { Subject, takeUntil } from 'rxjs';
import { removeRecentAccountAction } from 'src/app/actions/account';
import { removeRecentAgentAction } from 'src/app/actions/agent';
import { removeRecentCustomerAction } from 'src/app/actions/customer/action';
import { removeRecentProjectAction } from 'src/app/actions/project';
import {
  removeRecentTaxAction,
  restrictCreateTaxToOutputTaxAction
} from 'src/app/actions/tax';
import { removeRecentTermAction } from 'src/app/actions/term';
import { UserDefaultService } from 'src/app/shared/services/user-default.service';
import { InvoiceService } from 'src/app/routes/ar/inv/inv.service';
import { CustomerInfoModalComponent } from 'src/app/shared-feature/components/modal/customer-info-modal/customer-info-modal.component';
import { InvoiceEmailModalComponent } from 'src/app/shared-feature/components/modal/invoice-email-modal/invoice-email-modal.component';
import { GLAccountSelectComponent } from 'src/app/shared-feature/components/select/gl-account-select/gl-account-select.component';
import { DocBaseService } from 'src/app/shared-feature/services/_base/doc-base.service';
import { DocListBaseService } from 'src/app/shared-feature/services/_base/doc-list-base.service';
import { AutoCodeService } from 'src/app/shared-feature/services/auto-code.service';
import { TransactionDetailColumnAdjustService } from 'src/app/shared-feature/services/transaction-detail-column-adjust.service';
import { TranscationDetailKeyKownService } from 'src/app/shared-feature/services/transcation-detail-key-kown.service';
import { EditView } from 'src/app/shared/base/edit-view';
import { ICategoryData } from 'src/app/shared/types/category';
import { TaxApiResponse } from 'src/app/shared/types/tax';

import { InvoiceListService } from '../inv-list.service';
import { PaginatedTableComponent } from 'src/app/shared/components/paginated-table/paginated-table.component';
import { ColumnOptions } from '@core';
import { ACLService } from '@delon/acl';

@Component({
  selector: 'app-inv-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.less'],
  standalone: false,
  providers: [
    {
      provide: DocListBaseService,
      useExisting: forwardRef(() => InvoiceListService)
    },
    {
      provide: DocBaseService,
      useExisting: forwardRef(() => InvoiceService)
    },
    {
      provide: InvoiceService,
      useFactory: (injector: Injector) => new InvoiceService(injector),
      deps: [Injector]
    },
    {
      provide: AutoCodeService,
      useFactory: (http: _HttpClient) => new AutoCodeService(http),
      deps: [_HttpClient]
    }
  ]
})
export class InvDetailComponent
  extends PaginatedTableComponent<InvoiceService>
  implements OnInit, AfterViewChecked, OnDestroy, AfterViewInit
{
  @ViewChild('emailPreview') emailPreview!: InvoiceEmailModalComponent;
  @ViewChild('custModal') customerInfoModal!: CustomerInfoModalComponent;
  @ViewChild('TextArea') notesTextArea!: ElementRef;
  @ViewChild('linesTable') nzTableComponent?: NzTableComponent<any>;
  @ViewChild('birComponent') birComponent!: any;
  @ViewChild('customerNameInput') customerNameInput!: any;

  @ViewChildren(GLAccountSelectComponent)
  stockSelections!: QueryList<GLAccountSelectComponent>;
 
  override visibleColumns: ColumnOptions[] = [];

@HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (window.app && window.app.forcereload) {
      $event.returnValue = null;
      return;
    }
    if (this.modified) {
      $event.returnValue = null;
    } else $event.returnValue = true;
  }

  isEnableDeferredVatLookupSrv: boolean = true;
  columns = this.dataSrv.visibleColumns;


  get id() {
    return this.route.snapshot.params['id'];
  }

  get title() {
    if (this.isPast) {
      return 'Past Invoice';
    }
    return 'Invoice';
  }

  get isPast() {
    return this.dataSrv.form.controls.isPast.value;
  }

  get isGovBirCat(): boolean {
    return this.dataSrv.isGovBirCat;
  }

  get isPostedFromCs(): boolean {
    if (this.dataSrv.form.controls.fromCashSaleId.value) return true;
    return false;
  }

  get country() {
    return this.settings.user['company'].country;
  }

  get form() {
    return this.dataSrv.form;
  }

  get additionalData() {
    return {
      customerName: this.form.get('customerName')?.value
    };
  }

  get details() {
    return this.form.controls.details;
  }
  destroy$ = new Subject<void>();
  public recentAccountControlIndex?: number;
  public recentTaxControlIndex?: number;

  constructor(
    private route: ActivatedRoute,
    public msgSrv: NzMessageService,
    public override dataSrv: InvoiceService,
    private titleSrv: TitleService,
    private reuseTabSrv: ReuseTabService,
    public settings: SettingsService,
    public router: Router,
    public override keyDownService: TranscationDetailKeyKownService,
    public columnAdjustService: TransactionDetailColumnAdjustService,
    public override cdr: ChangeDetectorRef,
    private injector: Injector,
    private store: Store<{
      customer: { recentCustomer: any };
      term: { recentTerm: any };
      agent: { recentAgent: any };
      project: { recentProject: any };
      account: { recentAccount: any };
      tax: { recentTax: TaxApiResponse['data'] };
    }>,
    private userDefaultService: UserDefaultService
  ) {
    super(dataSrv, cdr, keyDownService);

    this.dataSrv.newLineAdded$.subscribe(() => {
      this.newlyAddedLine = true;
    });

    this.dataSrv.lineValueChanged.subscribe(({ line, controlName }) => {
      const index = this.dataSrv.details.controls.indexOf(line);
      this.keyDownService.focusNextElement(
        index,
        controlName,
        this.columns,
        this.editableCells.toArray()
      );
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @ViewChildren('inputWrapper') inputWrappers!: QueryList<ElementRef>;

  ngOnInit(): void {
    this.checkDeferredVatSetting();
    this.dataSrv.initialColumns = this.columns.filter(
      col =>
        (!col.acl || this.dataSrv.acl.canAbility(col.acl)) &&
        (!col.isGov || col.isGov === this.isGovBirCat)
    );

    if (this.dataSrv.id === '0') {
      this.titleSrv.setTitle('Invoice - New');
      this.reuseTabSrv.title = 'Invoice - New';
    }

    this.columnAdjustService.setInitialColumn(this.dataSrv.initialColumns);

    const savedOrder = this.columnAdjustService.loadColumnOrder('inv');
    if (savedOrder) {
      this.columns.sort((b, a) => savedOrder[b.key] - savedOrder[a.key]);
    }
    this.store.dispatch(removeRecentCustomerAction());
    this.store.dispatch(removeRecentAgentAction());
    this.store.dispatch(removeRecentTermAction());
    this.store.dispatch(removeRecentProjectAction());
    this.store.dispatch(removeRecentAccountAction());
    this.store.dispatch(removeRecentTaxAction());

    if (this.id == 0) {
      this.onAddNewCustomer();
      this.onAgentAdded();
      this.onTermAdded();
      this.onProjectCreate();
      this.onAccountCreate();
      this.onTaxCreate();
    }
  }

  checkDeferredVatSetting() {
    if (this.country === 'PH') {
      this.injector
        .get(DeferredVatLookupService)
        .loadDeferredVatSettings()
        .subscribe(res => {
          this.isEnableDeferredVatLookupSrv = res === null ? false : res;
          this.dataSrv.form.controls.enableDeferredVat.setValue(
            this.isEnableDeferredVatLookupSrv
          );
        });
    }
  }

  private onTaxCreate() {
    // this.store.dispatch(restrictCreateTaxToOutputTaxAction({ restrict: true }));
    this.store
      .select('tax')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentTax === null) return;
        if (
          isNull(this.recentTaxControlIndex) ||
          isUndefined(this.recentTaxControlIndex) ||
          this.form.controls.details.at(this.recentTaxControlIndex).controls
            .taxCode.value
        )
          return;
        const rowControl = this.form.controls.details.at(
          this.recentTaxControlIndex
        );
        rowControl.controls.taxAmount.setValue(state.recentTax.rate);
        rowControl.controls.taxCode.setValue(state.recentTax);
        rowControl.controls.taxRate.setValue(state.recentTax.rate);
        rowControl.controls.taxCodeId.setValue(state.recentTax.id);
      });
  }
  private onAccountCreate() {
    this.store
      .select('account')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentAccount === null) return;
        if (
          isNull(this.recentAccountControlIndex) ||
          isUndefined(this.recentAccountControlIndex) ||
          this.form.controls.details.at(this.recentAccountControlIndex).controls
            .account.value
        )
          return;
        const rowControl = this.form.controls.details.at(
          this.recentAccountControlIndex
        );
        const accountInfo = {
          id: state.recentAccount.id,
          code: state.recentAccount.code,
          name: state.recentAccount.name,
          specialCode: state.recentAccount.specialCode,
          currencyCode: state.recentAccount.currency.code,
          tariffCodeId: state.recentAccount.tariffCodeId,
          matchType: state.recentAccount.accountTypeId
        };
        rowControl.controls.account.setValue(accountInfo);
        rowControl.controls.accountId.setValue(accountInfo.id);
      });
  }
  private onProjectCreate() {
    this.store
      .select('project')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentProject === null) return;
        if (
          this.form.controls.projectId.value ||
          this.form.controls.project.value
        )
          return;
        this.form.controls.project.setValue(state.recentProject);
        this.form.controls.projectId.setValue(state.recentProject.id);
      });
  }
  private onAgentAdded() {
    this.store
      .select('agent')
      .pipe(takeUntil(this.destroy$))
      .subscribe(agent => {
        if (this.dataSrv.form.controls.agentId.value) return;
        if (agent.recentAgent) {
          this.dataSrv.form.controls.agentId.setValue(agent.recentAgent.id);
          this.dataSrv.form.controls.agent.setValue(agent.recentAgent);
        }
      });
  }
  private onTermAdded() {
    this.store
      .select('term')
      .pipe(takeUntil(this.destroy$))
      .subscribe(term => {
        if (this.dataSrv.form.controls.termId.value) return;
        if (term.recentTerm) {
          this.dataSrv.form.controls.termId.setValue(term.recentTerm.id);
          this.dataSrv.form.controls.term.setValue(term.recentTerm);
        }
      });
  }
  onAddNewCustomer() {
    this.store
      .select('customer')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentCustomer === null) return;
        this.form.controls.customer.setValue(state.recentCustomer);
        this.form.controls.customerId.setValue(state.recentCustomer?.id);
        this.form.controls.customerName.setValue(state.recentCustomer?.name);
        this.form.controls.customerPhone.setValue(
          state.recentCustomer?.phoneNo1
        );
        this.form.controls.customerTinType.setValue(
          state.recentCustomer?.tinType
        );
      });
  }
 get acl() {
    return this.injector.get(ACLService);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      // run if clone
      if (
        this.isGovBirCat &&
        this.dataSrv.form.controls.customer.value !== null
      ) {
        this.reloadDetailTable();
        this.cdr.detectChanges();
      }

      this.dataSrv.setFromRecurring();
    }, 0);
    this.inputWrappers.forEach(wrapper => {
      this.userDefaultService.setRequiredValidation(wrapper);
    });

    this.dataSrv.validateTaxDate();

    this.visibleColumns = this.columns.filter(
      col => (!col.acl || this.acl.canAbility(col.acl)) 
    ) as ColumnOptions[];
    this.keyDownService.updateColumnOrder(this.visibleColumns);
  }

  get modified() {
    return this.dataSrv.modified;
  }

  get collapsed() {
    return this.settings.layout.collapsed;
  }

  onResize({ width }: NzResizeEvent, col: any): void {
    col.width = `${width}px`;
  }

  updateLatestRate() {
    this.dataSrv.updateLatestRate();
  }

  updateCustModal(data: any) {
    this.dataSrv.updateCustInfo(data);
  }

  openCustModal() {
    // Pass existing data to ensure data recovery can be done when changes are cancelled
    this.customerInfoModal.show(this.dataSrv.form.value, 'INV');
  }

  ngAfterViewChecked() {
    if (this.newlyAddedLine) {
      this.focusNewLineStockSelect();
      this.newlyAddedLine = false;
    }
  }

  onCustomerChange() {
    if (this.dataSrv.editing){
      // Focus on customer name field after customer selection
      setTimeout(() => {
        if (this.customerNameInput) {
          this.customerNameInput.focus();
        }
      }, 100);
    }
  }

   reloadDetailTable() {
    this.columns = this.dataSrv.visibleColumns;
    this.dataSrv.initialColumns = this.columns.filter(
      col =>
        (!col.acl || this.dataSrv.acl.canAbility(col.acl)) &&
        (!col.isGov || col.isGov === this.dataSrv.form.controls.isGovCat.value)
    );

    this.columnAdjustService.setInitialColumn(this.dataSrv.initialColumns);

    const savedOrder = this.columnAdjustService.loadColumnOrder('inv');
    if (savedOrder) {
      this.columns.sort((b, a) => savedOrder[b.key] - savedOrder[a.key]);
    }
  }

  /**
   * Focuses on the last stock selection element in the array.
   */
  private focusNewLineStockSelect() {
    const stockSelectionArray = this.stockSelections.toArray();
    if (stockSelectionArray.length > 0) {
      const newLineStockSelect =
        stockSelectionArray[stockSelectionArray.length - 1];
      newLineStockSelect.focus();
    }
  }

  columnOrder: string[] = [];
  override selectComponentArray: string[] = [
    'stock',
    'project',
    'uom',
    'stockLocation',
    'taxCode',
    'wTaxCode',
    'account',
    'classification',
    'tariffCode',
    'taxAmountAdjustment',
    'wTaxAmountAdjustment'
  ];
  @ViewChildren('editableCell') override editableCells!: QueryList<ElementRef>;

  
  timestamp() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    var formattedTimestamp = null;
    if (this.settings.user['country'] === 'MY')
      formattedTimestamp = `${day}/${month}/${year} ${hours}:${minutes}:${seconds} - ${this.settings.user['displayName']}:`;
    if (this.settings.user['country'] === 'PH')
      formattedTimestamp = `${month}/${day}/${year} ${hours}:${minutes}:${seconds} - ${this.settings.user['displayName']}:`;
    if (this.dataSrv.form.controls.notes.value)
      formattedTimestamp = `${this.dataSrv.form.controls.notes.value}\n${formattedTimestamp}`;

    this.dataSrv.form.controls.notes.setValue(formattedTimestamp);
    this.notesTextArea.nativeElement.focus();
  }

}
